export type TrackingImpactVariant = "audience" | "design" | "combined";

export interface TrackingImpactInput {
  hasTrackingConfig: boolean;
  audienceChanged?: boolean;
  recipientCountChanged?: boolean;
  designChanged?: boolean;
  placeholderSetChanged?: boolean;
  formatChanged?: boolean;
}

export const doesChangeImpactTracking = (input: TrackingImpactInput): TrackingImpactVariant | null => {
  if (!input.hasTrackingConfig) {
    return null;
  }
  if (input.formatChanged && input.placeholderSetChanged) {
    return "combined";
  }
  if (input.designChanged && input.placeholderSetChanged) {
    return "design";
  }
  if (input.audienceChanged && input.recipientCountChanged) {
    return "audience";
  }
  return null;
};

export interface InvalidationCopy {
  title: string;
  body: string;
  confirmLabel: string;
}

export const TRACKING_INVALIDATION_COPY: Record<TrackingImpactVariant, InvalidationCopy> = {
  audience: {
    title: "Update audience?",
    body: "Changing the audience clears the tracking configuration tied to your previous audience. You'll need to set it up again.",
    confirmLabel: "Change audience",
  },
  design: {
    title: "Update design?",
    body: "This design's placeholders no longer support your tracking configuration. Continuing will clear the affected tracking setup.",
    confirmLabel: "Change design",
  },
  combined: {
    title: "Update design?",
    body: "This design changes the campaign cost and its placeholders no longer support your tracking configuration. Continuing recalculates the cost and clears the tracking setup.",
    confirmLabel: "Change design",
  },
};
